import React from 'react'

import LogoProyecto from './../../UI/Logos/logo-proyecto.svg'

interface Props{
    isLoading: boolean
    isWelcome: boolean
    handleHideWelcome: any
}

interface State{}

class WelcomeScreen extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(){
        return(
            <div className={this.props.isLoading || this.props.isWelcome ? "welcome-container fade-out":"welcome-container fade-in"}>
                <div className='logo-proyecto-container'>
                    <img src={LogoProyecto} alt=""/>
                </div>
                <div className='text-container'>
                    <div className='legal-text'>
                    Esta es una representación gráfica ilustrativa del proyecto con una sugerencia de amoblamiento. Los muebles que aparecen son de carácter decorativo no incluidos dentro de la oferta comercial. El área total está discriminada en: área privada, área común (ductos, columnas, estructura, muros divisorios y muros de fachada) y área de balcones cuando aplica. <br />
                    <br /> El área de terrazas no se suma dentro del área total por ser de uso común y exclusivo. Pueden presentarse variaciones en algunos detalles de diseño y acabados. Áreas y precios indicados son de referencia y corresponden a cada unidad. El precio del inmueble podrá tener variaciones antes de la separación del inmueble, dependiendo de las condiciones de mercado y disponibilidad de unidades.
                    </div>
                </div>
                <div className='btn-ingreso' onClick={() => {this.props.handleHideWelcome()}}>Ingresar</div>
            </div>
        )
    }
}

export default WelcomeScreen